import { isArray, isString, } from "./wsi4_typeguards";
import { isInstanceOf, } from "./aux";
import { isInvalidLayered, isInvalidInput, } from "./import";
function isErrorMessage(t) {
    const typeGuardMap = {
        tag: (arg) => arg === "ErrorMessage",
        message: isString,
    };
    return isInstanceOf(t, typeGuardMap);
}
function isImportError(t) {
    return isInvalidLayered(t) || isInvalidInput(t);
}
function isImportErrors(t) {
    const typeGuardMap = {
        tag: (arg) => arg === "ImportErrors",
        errors: (arg) => isArray(arg, isImportError),
    };
    return isInstanceOf(t, typeGuardMap);
}
export function isScriptError(m) {
    return isImportErrors(m) || isErrorMessage(m);
}
